// from is-network-error library
const ERROR_MESSAGES = new Set([
  'network error', // Chrome
  'Failed to fetch', // Chrome
  'NetworkError when attempting to fetch resource.', // Firefox
  'The Internet connection appears to be offline.', // Safari 16
  'Load failed', // Safari 17+
  'Network request failed', // `cross-fetch`
  'fetch failed', // Undici (Node.js)
]);

export const isNetworkError = (error: unknown): error is Error => {
  const isValidError =
    error instanceof Error &&
    error.name === 'TypeError' &&
    typeof error.message === 'string';

  if (!isValidError) {
    return false;
  }

  // Extra check for Safari 17+, network errors in Safari have no stack.
  if (error.message === 'Load failed') {
    return error.stack === undefined;
  }

  return ERROR_MESSAGES.has(error.message);
};
